import css from 'styled-jsx/css';

import { Color, Font } from 'src/theme';

export const styles = css.global`
  :root {
    --ripple-position-left: 0;
    --ripple-position-top: 0;
    --shadow-button-active: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);
    --shadow-button-hover: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    --shadow-button: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0,0,0, 0.12);
  }
  * {
    box-sizing: border-box;
  }
  html {
    font-size: 62.5%;
  }
  html::-webkit-scrollbar {
    display:none;
  }
  body {
    -webkit-font-smoothing: antialiased;
    background-color: ${Color.BackgroundDefault};
    color: ${Color.TextDefault};
    font-size: ${Font.SizeDefault};
    line-height: calc(20 / 14);
    margin: 0;
    min-width: 800px;
  }
  .MuiTableCell-root {
    font-size: ${Font.SizeDefault} !important;
  }
  a {
    color: ${Color.TextLink};
    text-decoration: none;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  h2,
  h3 {
    color: ${Color.TextLight};
  }
  h2 {
    font-size: 28px;
    font-weight: normal;
  }
  input,
  textarea {
    border: none;
    outline: none;
  }
  .flex {
    display: flex;
  }
  .text {
    white-space: pre-wrap;
  }
  div[role=dialog] {
    margin: auto;
  }
  div[role=dialog] h4 {
  color: ${Color.TextDefault};
  }
`;
